import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';
import { Link } from '@tanstack/react-router';

const AppHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <Link to="/app">
        <CampdeskLogo />
      </Link>
    </div>
  );
};

export default AppHeader;
